import "core-js/modules/es.object.to-string";
import "regenerator-runtime/runtime";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { sendCmd, fdLogImport } from '../../../../api/apis';
export default {
  data: function data() {
    return {
      dialogVisible: false,
      form: {
        startDate: "",
        endDate: ""
      },
      rules: {
        startDate: [{
          required: true,
          message: "请选择起始日期",
          trigger: "change"
        }],
        endDate: [{
          required: true,
          message: "请选择结束日期",
          trigger: "change"
        }]
      },
      loadInfo: {
        ret: true,
        total: 0,
        info: ''
      }
    };
  },
  mounted: function mounted() {},
  methods: {
    show: function show() {
      this.dialogVisible = true;
    },
    clickSubmit: function clickSubmit() {
      var _this = this;

      this.$refs['form'].validate(function (valid) {
        if (valid) {
          if (!_this.loadInfo.ret) {
            _this.$message({
              message: '请先导入表格',
              type: 'error'
            });

            return;
          }

          _this.$g.fun.startLoading();

          fdLogImport({
            data_list: _this.userList
          }).then(function _callee2(res) {
            var params;
            return regeneratorRuntime.async(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    params = ['stabonus9'];
                    sendCmd(params).then(function _callee(res) {
                      return regeneratorRuntime.async(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              _this.$alert('提交成功，请等待2分钟后刷新文件列表', '提示', {
                                confirmButtonText: '确定'
                              });

                              _this.dialogVisible = false;

                              _this.$g.fun.endLoading();

                            case 3:
                            case "end":
                              return _context.stop();
                          }
                        }
                      });
                    });

                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            });
          });
        }
      });
    },
    handleImport: function handleImport(file) {
      var _this2 = this;

      this.$import.xlsx(file).then(function (_ref) {
        var header = _ref.header,
            results = _ref.results;

        if (results.length === 0) {
          return;
        }

        var item = results[0];

        if (!item.hasOwnProperty('会员编号') || !item.hasOwnProperty('奖金')) {
          _this2.$message({
            message: '表格字段错误',
            type: 'error'
          });

          return;
        }

        var tmp = [];
        var dic = {};
        _this2.loadInfo.total = results.length;
        _this2.loadInfo.info = "";

        for (var i in results) {
          var number = results[i]['会员编号'];

          if (dic.hasOwnProperty(number)) {
            _this2.loadInfo.ret = false;
            _this2.loadInfo.info = number + "编号重复";
            return;
          }

          dic[number] = 1;
          tmp.push({
            number: number,
            bonus: results[i]['奖金']
          });
        }

        _this2.loadInfo.ret = true;
        _this2.userList = tmp;
      }); // 阻止默认的上传

      return false;
    }
  }
};